/**
 * Input Slider
 */
import { Component, registerComponent } from 'js/component.js';
const componentName = 'input-slider';

export class InputSlider extends Component {

    /**
     * Component Setup
     */
    // State
    state = {
        theme: this.element.querySelector('div[data-theme]').getAttribute('data-theme'),
    };

    // Elements
    elements = {
        container: this.element.querySelector(`.${this.state.theme}-formfield__container`),
        rangeSliderContainer: this.element.querySelector(`.${this.state.theme}-input__slider-range-container`),
        rangeValLeft: this.element.querySelector(`.${this.state.theme}-input__range-slider-val-left`),
        rangeValRight: this.element.querySelector(`.${this.state.theme}-input__range-slider-val-right`),
        rangeValRange: this.element.querySelector(`.${this.state.theme}-input__range-slider-val-range`),
        rangeHandleLeft: this.element.querySelector(`.${this.state.theme}-input__range-slider-handle-left`),
        rangeHandleRight: this.element.querySelector(`.${this.state.theme}-input__range-slider-handle-right`),
        rangeTooltipLeft: this.element.querySelector(`.${this.state.theme}-input__range-slider-tooltip-left`),
        rangeTooltipRight: this.element.querySelector(`.${this.state.theme}-input__range-slider-tooltip-right`),
        rangeInputLeft: this.element.querySelector(`.${this.state.theme}-input__range-slider-input-left`),
        rangeInputRight: this.element.querySelector(`.${this.state.theme}-input__range-slider-input-right`),
        rangeInput: this.element.querySelector(`.${this.state.theme}-input__range-slider-input`),
    };

    /**
     * Add Event Listeners
     */
    addEventListeners = () => {
        if (this.elements.rangeInput) {
            this.elements.rangeInput.addEventListener('input', () => {
                const value = (100 / (parseFloat(this.state.rangeSliderMax) - parseFloat(this.state.rangeSliderMin))) * parseFloat(this.elements.rangeInput.value) - (100 / (parseFloat(this.state.rangeSliderMax) - parseFloat(this.state.rangeSliderMin))) * parseFloat(this.state.rangeSliderMin);

                this.elements.rangeValRight.style.setProperty('--slider-width', `${100 - value}%`);
                this.elements.rangeValRange.style.setProperty('--slider-right-offset', `${100 - value}%`);
                this.elements.rangeHandleRight.style.setProperty('--slider-left-offset', `${value}%`);
                this.elements.rangeHandleRight.style.setProperty('--slider-right-offset', `${100 - value}%`);
                this.elements.rangeTooltipRight.style.setProperty('--slider-left-offset', `${value}%`);

                this.elements.rangeTooltipRight.querySelector('span').innerText = this.elements.rangeInput.value;
            });
        }

        if (this.elements.rangeInputLeft) {
            this.elements.rangeInputLeft.addEventListener('input', () => {
                this.elements.rangeInputLeft.value = Math.min(parseFloat(this.elements.rangeInputLeft.value), parseFloat(this.elements.rangeInputRight.value) - this.state.rangeSliderStep);
                const value = (100 / (parseFloat(this.state.rangeSliderMax) - parseFloat(this.state.rangeSliderMin))) * parseFloat(this.elements.rangeInputLeft.value) - (100 / (parseFloat(this.state.rangeSliderMax) - parseFloat(this.state.rangeSliderMin))) * parseFloat(this.state.rangeSliderMin);

                this.elements.rangeValLeft.style.setProperty('--slider-width', `${value}%`);
                this.elements.rangeValRange.style.setProperty('--slider-left-offset', `${value}%`);
                this.elements.rangeHandleLeft.style.setProperty('--slider-left-offset', `${value}%`);
                this.elements.rangeTooltipLeft.style.setProperty('--slider-left-offset', `${value}%`);

                this.elements.rangeTooltipLeft.querySelector('span').innerText = this.elements.rangeInputLeft.value;
            });
        }

        if (this.elements.rangeInputRight) {
            this.elements.rangeInputRight.addEventListener('input', () => {
                this.elements.rangeInputRight.value = Math.max(parseFloat(this.elements.rangeInputRight.value), parseFloat(this.elements.rangeInputLeft.value) + this.state.rangeSliderStep);
                const value = (100 / ( parseFloat(this.state.rangeSliderMax) - parseFloat(this.state.rangeSliderMin))) * parseFloat(this.elements.rangeInputRight.value) - (100 / ( parseFloat(this.state.rangeSliderMax) - parseFloat(this.state.rangeSliderMin))) * parseFloat(this.state.rangeSliderMin);

                this.elements.rangeValRight.style.setProperty('--slider-width', `${100 - value}%`);
                this.elements.rangeValRange.style.setProperty('--slider-right-offset', `${100 - value}%`);
                this.elements.rangeHandleRight.style.setProperty('--slider-left-offset', `${value}%`);
                this.elements.rangeHandleRight.style.setProperty('--slider-right-offset', `${100 - value}%`);
                this.elements.rangeTooltipRight.style.setProperty('--slider-left-offset', `${value}%`);

                this.elements.rangeTooltipRight.querySelector('span').innerText = this.elements.rangeInputRight.value;
            });
        }
    };

    initDom = () => {
        this.state.isRangeSlider = this.elements.container.getAttribute('data-range-slider') === 'true';
        this.state.rangeSliderMin = this.elements.rangeSliderContainer ? parseFloat(this.elements.rangeSliderContainer.getAttribute('data-min')) : 0;
        this.state.rangeSliderMax = this.elements.rangeSliderContainer ? parseFloat(this.elements.rangeSliderContainer.getAttribute('data-max')) : 100;
        this.state.rangeSliderStep = this.elements.rangeSliderContainer ? parseFloat(this.elements.rangeSliderContainer.getAttribute('data-step')) : 1;
        this.elements.rangeValRight.style.setProperty('--slider-width', '100%');
        this.elements.rangeValRange.style.setProperty('--slider-left-offset', '0%');
        this.elements.rangeValRange.style.setProperty('--slider-right-offset', '0%');
        this.elements.rangeHandleRight.style.setProperty('--slider-left-offset', '100%');
        this.elements.rangeTooltipRight.style.setProperty('--slider-left-offset', '100%');
        this.elements.rangeTooltipRight.querySelector('span').innerText = this.state.rangeSliderMax;

        if (this.state.isRangeSlider) {
            this.state.rangeSliderDefaultValueMin = this.elements.rangeSliderContainer ? parseFloat(this.elements.rangeSliderContainer.getAttribute('data-default-value-min')) : 0;
            this.state.rangeSliderDefaultValueMax = this.elements.rangeSliderContainer ? parseFloat(this.elements.rangeSliderContainer.getAttribute('data-default-value-max')) : 100;
            this.elements.rangeValLeft.style.setProperty('--slider-width', '100%');
            this.elements.rangeHandleLeft.style.setProperty('--slider-left-offset', '0%');
            this.elements.rangeTooltipLeft.style.setProperty('--slider-left-offset', '0%');
            this.elements.rangeTooltipLeft.querySelector('span').innerText = this.state.rangeSliderMin;
            this.elements.rangeInputLeft.value = this.state.rangeSliderDefaultValueMin;
            this.elements.rangeInputLeft.dispatchEvent(new Event('input'));
            this.elements.rangeInputRight.value = this.state.rangeSliderDefaultValueMax;
            this.elements.rangeInputRight.dispatchEvent(new Event('input'));
        } else {
            this.state.rangeSliderDefaultValue = this.elements.rangeSliderContainer ? parseFloat(this.elements.rangeSliderContainer.getAttribute('data-default-value')) : 100;
            this.elements.rangeInput.value = this.state.rangeSliderDefaultValue;
            this.elements.rangeInput.dispatchEvent(new Event('input'));
        }
    };

    /**
     * Initialize Component
     */
    init() {
        this.addEventListeners();
        this.initDom();
    }
}

registerComponent(`.${componentName}`, InputSlider);
